module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    staticClass: "stats-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Stats")]), _vm._v(" "), (_vm.$store.getters.stopped) ? _c('span', {
    staticClass: "stopwarn"
  }, [_vm._v("Not running")]) : _vm._e()]), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "kv-key",
    attrs: {
      "span": 6
    }
  }, [_vm._v(" Project name")]), _vm._v(" "), _c('el-col', {
    staticClass: "kv-value",
    attrs: {
      "span": 18
    }
  }, [_vm._v(" " + _vm._s(_vm.$store.state.name) + " ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "kv-key",
    attrs: {
      "span": 6
    }
  }, [_vm._v(" Start time ")]), _vm._v(" "), _c('el-col', {
    staticClass: "kv-value",
    attrs: {
      "span": 18
    }
  }, [_vm._v(" " + _vm._s(_vm.getStartTime) + " ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "kv-key",
    attrs: {
      "span": 6
    }
  }, [_vm._v("Expected end time")]), _vm._v(" "), _c('el-col', {
    staticClass: "kv-value",
    attrs: {
      "span": 18
    }
  }, [_vm._v(" " + _vm._s(_vm.getExpectedEndTime) + " ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "kv-key",
    attrs: {
      "span": 6
    }
  }, [_vm._v(" Chips tested ")]), _vm._v(" "), _c('el-col', {
    staticClass: "kv-value",
    attrs: {
      "span": 18
    }
  }, [_vm._v(" " + _vm._s(_vm.getChipTested) + " ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "kv-key",
    attrs: {
      "span": 6
    }
  }, [_vm._v("Total retries done")]), _vm._v(" "), _c('el-col', {
    staticClass: "kv-value",
    attrs: {
      "span": 18
    }
  }, [_vm._v(" " + _vm._s(_vm.getTotalRetries) + " ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "kv-key",
    attrs: {
      "span": 6
    }
  }, [_vm._v(" Overall progress ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-progress', {
    attrs: {
      "text-inside": true,
      "stroke-width": 18,
      "percentage": _vm.getOverallProgress
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "kv-key",
    attrs: {
      "span": 6
    }
  }, [_vm._v(" Average chip time ")]), _vm._v(" "), _c('el-col', {
    staticClass: "kv-value",
    attrs: {
      "span": 18
    }
  }, [_vm._v(" " + _vm._s(_vm.getAverageChipTime) + " ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "kv-key",
    attrs: {
      "span": 6
    }
  }, [_vm._v(" Chips accepted ")]), _vm._v(" "), _c('el-col', {
    staticClass: "kv-value",
    attrs: {
      "span": 18
    }
  }, [_vm._v(" " + _vm._s(_vm.$store.state.counters.ok) + " (" + _vm._s(_vm.getOKPercentage) + "%) ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "kv-key",
    attrs: {
      "span": 6
    }
  }, [_vm._v("Total Chips rejected")]), _vm._v(" "), _c('el-col', {
    staticClass: "kv-value",
    attrs: {
      "span": 18
    }
  }, [_vm._v(_vm._s(_vm.getRejectedCurrentSum))])], 1), _vm._v(" "), _vm._l((_vm.$store.state.counters.rejects), function(reject, ir) {
    return _c('el-row', {
      key: ir
    }, [_c('el-col', {
      staticClass: "kv-key",
      attrs: {
        "span": 6
      }
    }, [_vm._v(" Chips rejected for sink " + _vm._s(ir))]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 18
      }
    }, [_c('div', {
      staticStyle: {
        "margin-bottom": "5px"
      }
    }, [_vm._v(_vm._s(reject.current) + " for " + _vm._s(reject.id) + " errors out for " + _vm._s(reject.total) + " available positions")]), _vm._v(" "), _c('el-progress', {
      attrs: {
        "status": "exception",
        "text-inside": true,
        "stroke-width": 18,
        "percentage": Math.round((reject.current / reject.total) * 100)
      }
    })], 1)], 1)
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "kv-key",
    attrs: {
      "span": 6
    }
  }, [_vm._v("Last update")]), _vm._v(" "), _c('el-col', {
    staticClass: "kv-value",
    attrs: {
      "span": 18
    }
  }, [_vm._v(_vm._s(_vm.getLastUpdate))])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0733dfda","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/stats-card.vue
// module id = 706
// module chunks = 1